import React from 'react';
import {generalStore, modalStore, projectStore} from '../../index';

const renderBody = (folder) => (
    <div>
        {generalStore.translate('deleteFolderConfirmSentence1_beforeName')}{' '}
        <span className="font-semibold">{folder.FolderName}</span>{' '}
        {generalStore.translate('deleteFolderConfirmSentence2_afterName')}
    </div>
);

const executeDelete = async (folder) => {
    await projectStore.deleteFolder(folder);
    await projectStore.refreshCurrentFolderLevel();
};

export const openDeleteFolderConfirm = (folder) => {
    modalStore.modalData = {
        title: generalStore.translate('deleteFolder'),
        bodyText: renderBody(folder),
        confirmText: generalStore.translate('delete'),
        isDelete: true,
        confirmActions: () => modalStore.runAsync(
            executeDelete(folder),
            generalStore.translate('problemDeletingFolder'),
            generalStore.translate('folderDeleted'),
            generalStore.translate('deletingFolder') + '...',
        ),
    };
    modalStore.isGeneralConfirmActionDialogOpen = true;
};
